import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ToolsClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.module.css");
